<template>
  <div>
    <vs-button class="block ml-auto mb-4" @click="addTeacher"
      >Add Teacher</vs-button
    >
    <vs-table
      class="cstm_vuexy_table"
      v-model="selected"
      :data="sharedEnrolledUser"
    >
      <template slot="thead">
        <vs-th style="width: 80px">Image</vs-th>
        <vs-th> Name </vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].picture">
            <img
              class="imgpic"
              v-if="data[indextr].picture"
              :src="data[indextr].picture"
              style="height: 40px; width: 40px; object-fit: contain"
            />
            <img
              class="imgpic"
              v-else
              src="http://scoolio-dev.track-progress.com/img/user-circle-solid.c3580913.svg"
              style="height: 40px; width: 40px; object-fit: contain"
            />
          </vs-td>
          <vs-td :data="data[indextr].first_name">
            {{ data[indextr].first_name }}
            {{ data[indextr].last_name }}
          </vs-td>
          <td style="width: 20px">
            <span
              style="cursor: pointer"
              class="material-icons-outlined"
              @click="openConfirm(indextr)"
              >delete</span
            >
          </td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-popup title="Add Teacher" :active.sync="addTeacherModal">
      <label>Teachers</label>
      <v-select
        multiple
        v-model="tutors"
        :getOptionLabel="(item) => `${item.first_name} ${item.last_name}`"
        class="w-full h-full"
        placeholder="Select Teacher"
        :clearable="false"
        :options="teacherList"
        @open="onOpenTeacher"
        @close="onCloseTeacher"
        @search="fuseSearch"
      >
        <template v-slot:selected-option="teacherList">
          <img
            v-if="teacherList.picture"
            class="person-img rounded-full"
            :src="teacherList.picture"
          />
          <img
            v-else
            class="person-img rounded-full"
            src="@/assets/images/pages/user-circle-solid.svg"
          />
          {{ teacherList.first_name }}
          {{ teacherList.last_name }}
        </template>
        <template v-slot:option="teacherList">
          <img
            v-if="teacherList.picture"
            class="person-img rounded-full"
            :src="teacherList.picture"
          />
          <img
            v-else
            class="person-img rounded-full"
            src="@/assets/images/pages/user-circle-solid.svg"
          />
          {{ teacherList.first_name }}
          {{ teacherList.last_name }}
        </template>
        <template #list-footer>
          <li ref="loadTeacher" class="loader" v-show="teacher_meta.has_next">
            Loading more teacher...
          </li>
        </template>
      </v-select>
      <div
        style="
          border-top: 1px solid #ccc;
          margin-top: 20px;
          padding: 10px 0 0;
          text-align: center;
        "
      >
        <vs-button @click="addTeacherToCourse">Save</vs-button>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import { CourseBuilder } from '@/views/pages/v1/coursebuilder/mixin/courseBuilderMixin.js'
import { submitCourseInterestapi } from '@/api/course-builderapi'
import { addUsertoCourseApi } from '@/api/courseBuilder'

export default {
  name: 'userInfoModal',
  components: {
    vSelect
  },
  mixins: [CourseBuilder],
  props: {
    courseId: {
      default: null
    },
    assignment_id: {
      default: null
    },
    Modaltype: {
      required: true,
      type: String
    },
    sharedEnrolledUser: {
      required: true,
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      tutors: [],
      addTeacherModal: false,
      selected: [],
      userInfo: [],
      selectedUserId: [],
      deleteIndex: null
    }
  },
  mounted () {
    this.tutors = this.sharedEnrolledUser
  },
  methods: {
    openConfirm (index) {
      this.deleteIndex = index
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure you want to delete this teacher?',
        accept: this.deleteTeacher
      })
    },
    async deleteTeacher () {
      this.sharedEnrolledUser.splice(this.deleteIndex, 1)
      const payload = {
        tutors: this.sharedEnrolledUser
      }
      await addUsertoCourseApi(
        this.$store.getters.customerId,
        this.courseId,
        payload
      ).then((data) => {
        this.addTeacherModal = false
        this.$emit('fetchTeacher', this.sharedEnrolledUser)
      })
    },
    async addTeacherToCourse () {
      const payload = {
        tutors: this.tutors
      }
      await addUsertoCourseApi(
        this.$store.getters.customerId,
        this.courseId,
        payload
      ).then((data) => {
        this.addTeacherModal = false
        this.$emit('fetchTeacher', this.tutors)
      })
    },
    addTeacher () {
      this.addTeacherModal = true
    },
    adminApproved (payload, courseId, UserId, Status, indextr) {
      this.submitCourseInterest(payload, courseId, UserId, Status, indextr)
    },
    async submitCourseInterest (payload, courseId, UserId, Status, indextr) {
      try {
        this.$vs.loading({
          text: 'Submitting Interest in this course'
        })
        const payload = {
          course_id: courseId,
          enrollment_status: Status,
          user_id: UserId
        }
        const customer_id = localStorage.getItem('customer_id')

        await submitCourseInterestapi(payload, customer_id)
        this.sharedEnrolledUser[indextr].enrollment_status = Status
      } catch (error) {
        this.$vs.loading.close()
      } finally {
        this.$vs.loading.close()
      }
    }
  },

  beforeDestroy () {},
  destroyed () {}
}
</script>

<style scoped>
.con-vs-popup .vs-popup {
  width: 700px;
}
.con-vs-popup .vs-popup {
  width: 800px;
}
</style>